// To be updated - give wikipedia page and ask to create in this format
const groups = [
    {
      "_id": "weuro2025a",
      "tournament": "weuro2025",
      "ref": "A",
      "name": "Group A",
      "teams": ["foot_is", "foot_fi", "foot_ch", "foot_no"], 
      "advanceType": "firsttwo"
    },
    {
      "_id": "weuro2025b",
      "tournament": "weuro2025",
      "ref": "B",
      "name": "Group B",
      "teams": ["foot_be", "foot_it", "foot_es", "foot_pt"],
      "advanceType": "firsttwo"
    },
    {
      "_id": "weuro2025c",
      "tournament": "weuro2025",
      "ref": "C",
      "name": "Group C",
      "teams": ["foot_dk", "foot_se", "foot_de", "foot_pl"], 
      "advanceType": "firsttwo"
    },
    {
      "_id": "weuro2025d",
      "tournament": "weuro2025",
      "ref": "D",
      "name": "Group D",
      "teams": ["foot_nl", "foot_fr", "foot_en", "foot_wl"],
      "advanceType": "firsttwo"
    }
  ];
  
/*
const groups = [
    { "_id": "wc2026a", "tournament": "wc2026", "ref": "A", "name": "Group A", "teams": ["foot_mx","foot_nl","foot_nl","foot_nl"], "advanceType": "firsttwo" },
    { "_id": "wc2026b", "tournament": "wc2026", "ref": "B", "name": "Group B", "teams": ["foot_ca","foot_nl","foot_nl","foot_nl"], "advanceType": "firsttwo" },
    { "_id": "wc2026c", "tournament": "wc2026", "ref": "C", "name": "Group C", "teams": ["foot_nl","foot_nl","foot_nl","foot_nl"], "advanceType": "firsttwo" },
    { "_id": "wc2026d", "tournament": "wc2026", "ref": "D", "name": "Group D", "teams": ["foot_us","foot_nl","foot_nl","foot_nl"], "advanceType": "firsttwo" },
    { "_id": "wc2026e", "tournament": "wc2026", "ref": "E", "name": "Group E", "teams": ["foot_nl","foot_nl","foot_nl","foot_nl"], "advanceType": "firsttwo" },
    { "_id": "wc2026f", "tournament": "wc2026", "ref": "F", "name": "Group F", "teams": ["foot_nl","foot_nl","foot_nl","foot_nl"], "advanceType": "firsttwo" },
    { "_id": "wc2026g", "tournament": "wc2026", "ref": "G", "name": "Group G", "teams": ["foot_nl","foot_nl","foot_nl","foot_nl"], "advanceType": "firsttwo" },
    { "_id": "wc2026h", "tournament": "wc2026", "ref": "H", "name": "Group H", "teams": ["foot_nl","foot_nl","foot_nl","foot_nl"], "advanceType": "firsttwo" },
    { "_id": "wc2026i", "tournament": "wc2026", "ref": "I", "name": "Group I", "teams": ["foot_nl","foot_nl","foot_nl","foot_nl"], "advanceType": "firsttwo" },
    { "_id": "wc2026j", "tournament": "wc2026", "ref": "J", "name": "Group J", "teams": ["foot_nl","foot_nl","foot_nl","foot_nl"], "advanceType": "firsttwo" },
    { "_id": "wc2026k", "tournament": "wc2026", "ref": "K", "name": "Group K", "teams": ["foot_nl","foot_nl","foot_nl","foot_nl"], "advanceType": "firsttwo" },
    { "_id": "wc2026l", "tournament": "wc2026", "ref": "L", "name": "Group L", "teams": ["foot_nl","foot_nl","foot_nl","foot_nl"], "advanceType": "firsttwo" }
]*/


/*[
    { "_id": "ec2024a", "tournament": "ec2024", "ref": "A", "name": "Group A", "teams": ["foot_de","foot_sc","foot_hu","foot_ch"], "advanceType": "firsttwoplus4three" },
    { "_id": "ec2024b", "tournament": "ec2024", "ref": "B", "name": "Group B", "teams": ["foot_es","foot_hr","foot_it","foot_al"], "advanceType": "firsttwoplus4three" },
    { "_id": "ec2024c", "tournament": "ec2024", "ref": "C", "name": "Group C", "teams": ["foot_si","foot_dk","foot_rs","foot_en"], "advanceType": "firsttwoplus4three" },
    { "_id": "ec2024d", "tournament": "ec2024", "ref": "D", "name": "Group D", "teams": ["foot_us","foot_nl","foot_at","foot_fr"], "advanceType": "firsttwoplus4three" },
    { "_id": "ec2024e", "tournament": "ec2024", "ref": "E", "name": "Group E", "teams": ["foot_be","foot_sk","foot_ro","foot_br"], "advanceType": "firsttwoplus4three" },
    { "_id": "ec2024f", "tournament": "ec2024", "ref": "F", "name": "Group F", "teams": ["foot_tr","foot_ar","foot_pt","foot_cz"], "advanceType": "firsttwoplus4three" },
]*/

/*[
    { "_id": "wc2022a", "tournament": "wc2022", "ref": "A", "name": "Group A", "teams": ["foot_qa","foot_ec","foot_sn","foot_nl"], "advanceType": "firsttwo" },
    { "_id": "wc2022b", "tournament": "wc2022", "ref": "B", "name": "Group B", "teams": ["foot_en","foot_ir","foot_us","foot_wl"], "advanceType": "firsttwo" },
    { "_id": "wc2022c", "tournament": "wc2022", "ref": "C", "name": "Group C", "teams": ["foot_ar","foot_sa","foot_mx","foot_pl"], "advanceType": "firsttwo" },
    { "_id": "wc2022d", "tournament": "wc2022", "ref": "D", "name": "Group D", "teams": ["foot_fr","foot_au","foot_dk","foot_tn"], "advanceType": "firsttwo" },
    { "_id": "wc2022e", "tournament": "wc2022", "ref": "E", "name": "Group E", "teams": ["foot_es","foot_cr","foot_de","foot_jp"], "advanceType": "firsttwo" },
    { "_id": "wc2022f", "tournament": "wc2022", "ref": "F", "name": "Group F", "teams": ["foot_be","foot_ca","foot_ma","foot_hr"], "advanceType": "firsttwo" },
    { "_id": "wc2022g", "tournament": "wc2022", "ref": "G", "name": "Group G", "teams": ["foot_br","foot_rs","foot_ch","foot_cm"], "advanceType": "firsttwo" },
    { "_id": "wc2022h", "tournament": "wc2022", "ref": "H", "name": "Group H", "teams": ["foot_pt","foot_gh","foot_uy","foot_kr"], "advanceType": "firsttwo" }
]*/

export default groups